import { useUserStore } from 'src/store/user-store';
import { useAvailableSites } from './api/use-available-sites';

export default function useSelectedSite() {
  const { data } = useAvailableSites();
  const { directoryToken } = useUserStore();

  const selectedSite = data?.resources.find(
    site => site.token === directoryToken,
  );

  return selectedSite;
}
